import { Component, Emit, Inject, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { mixins } from 'vue-class-component';
import { ProgramaIntegrado } from '@/shared/model/snp/programa-integrado.model';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { required } from 'vuelidate/lib/validators';
import { BvTableFieldArray } from 'bootstrap-vue';

const validations = function () {
  const { programaIntegradoConSeleccionado } = this as ProgramaIntegradoConListadoComponent;
  return {
    programaIntegradoConSeleccionado: {
      fechaInicio: { required },
      fechaFin: {
        minValue: val => {
          return val != undefined && programaIntegradoConSeleccionado.fechaInicio != undefined
            ? val >= programaIntegradoConSeleccionado.fechaInicio
            : true;
        },
      },
    },
  };
};
@Component({
  validations,
})
export default class ProgramaIntegradoConListadoComponent extends mixins(ApeironComponent) {
  @Inject('solicitudService') private solicitudService: () => SolicitudService;

  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public estaVisible: boolean;

  public programaIntegradoConSeleccionado: ProgramaIntegrado = new ProgramaIntegrado();

  public programasIntegrados: Array<ProgramaIntegrado> = [];

  public mostrarModalEliminar = false;
  public mostrarModalEditar = false;

  public programasIntegradosFields: BvTableFieldArray = [
    {
      key: 'clave',
      label: this.$t('apeironGwApp.programaIntegradoCon.form.clave').toString(),
      class: 'text-left font-weight-bold',
      thStyle: { width: '10rem' },
    },
    {
      key: 'nombre',
      label: this.$t('apeironGwApp.programaIntegradoCon.form.nombre').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'fechaInicio',
      label: this.$t('apeironGwApp.programaIntegradoCon.form.fechaInicio').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'fechaFin',
      label: this.$t('apeironGwApp.programaIntegradoCon.form.fechaFin').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'acciones',
      label: this.$t('entity.acciones').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
      thClass: this.esEscritura ? '' : 'd-none',
      tdClass: this.esEscritura ? '' : 'd-none',
    },
  ];

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('estaVisible')
  public watchEstaVisible(): void {
    if (this.estaVisible) {
      this.iniciarComponente();
    }
  }

  private iniciarComponente(): void {
    this.programaIntegradoConSeleccionado = new ProgramaIntegrado();
    this.solicitudService()
      .find(this.solicitud.id)
      .then(solicitud => {
        this.programasIntegrados = [];
        (solicitud.programasIntegrados ?? [])
          .filter(programa => programa.clave !== undefined)
          .forEach(programa => {
            this.programasIntegrados.push(ProgramaIntegrado.fromObject(programa));
          });
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }

  @Emit('guardarProgramasIntegrados')
  public guardarSeccion(programasIntegrados: Array<ProgramaIntegrado>): Array<ProgramaIntegrado> {
    return programasIntegrados;
  }

  @Emit('eliminarProgramaIntegrado')
  public eliminarProgramaIntegrado(): void {
    return;
  }

  public mostrarModalEliminarPrograma(programaIntegrado: ProgramaIntegrado): void {
    this.mostrarModalEliminar = true;
    this.programaIntegradoConSeleccionado = programaIntegrado;
  }

  public mostrarModalEditarPrograma(programaIntegrado: ProgramaIntegrado): void {
    this.programaIntegradoConSeleccionado = ProgramaIntegrado.fromObject(programaIntegrado);

    this.mostrarModalEditar = true;
  }

  public quitarFechaFin(): void {
    this.programaIntegradoConSeleccionado.fechaFin = undefined;
  }

  public eliminarPrograma(): void {
    this.mostrarModalEliminar = false;
    this.solicitudService()
      .find(this.solicitud.id)
      .then(solicitud => {
        solicitud.programasIntegrados = (solicitud.programasIntegrados ?? []).filter(
          programa => programa.clave !== this.programaIntegradoConSeleccionado.clave
        );

        this.solicitudService()
          .update(solicitud)
          .then(() => {
            this.iniciarComponente();
            this.eliminarProgramaIntegrado();
          })
          .catch(error => {
            this.alertService().showHttpError(this, error.response);
          });
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }

  public editarPrograma(): void {
    this.mostrarModalEditar = false;
    if (!this.readOnly) {
      if (!this.formularioIsInvalid) {
        this.solicitudService()
          .find(this.solicitud.id)
          .then(solicitud => {
            solicitud.programasIntegrados = (solicitud.programasIntegrados ?? []).filter(
              programa => programa.clave !== this.programaIntegradoConSeleccionado.clave
            );
            solicitud.programasIntegrados.push(this.programaIntegradoConSeleccionado);

            this.solicitudService()
              .update(solicitud)
              .then(() => {
                this.iniciarComponente();
                this.guardarSeccion(solicitud.programasIntegrados);
              })
              .catch(error => {
                this.alertService().showHttpError(this, error.response);
              });
          })
          .catch(error => {
            this.alertService().showHttpError(this, error.response);
          });
      } else {
        this.alertService().showWarning(this, this.$t('apeironGwApp.programaIntegradoCon.registro.formularioInvalido').toString());
      }
    }
  }

  get formularioIsInvalid(): boolean {
    return this.$v.$invalid;
  }

  get registros(): number {
    return this.programasIntegrados?.length ?? 0;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
